import { Chart } from "chart.js";
import ChartData from "components/Charts/types/ChartData";

import designTokens from "../../../../../../tokens/design-tokens.json";
import ChartColors from "../../../../../../config/ChartColors";

const createBarChart = (canvas: HTMLCanvasElement, data: ChartData) =>
    new Chart(canvas, {
        type: "bar",
        data: {
            labels: data.labels,
            datasets: data.datasets.map((dataset) => ({
                ...dataset,
                barThickness: 30,
            })),
        },
        options: {
            resizeDelay: 500,
            skipNull: true,
            maintainAspectRatio: false,
            responsive: true,
            scales: {
                x: {
                    ticks: {
                        color: ChartColors.midnight500,
                        font: {
                            family: "Boston",
                            weight: "700",
                            size: 14,
                        },
                    },
                    grid: {
                        display: false,
                    },
                },
                y: {
                    border: {
                        display: false,
                    },
                    ticks: {
                        stepSize: data.step || undefined,
                        padding: 10,
                        crossAlign: "far",
                        // Strips ',' to match the design. Adds a space as well
                        // otherwise it clips against the edge of th canvas for some reason.
                        callback: (string: string | number) => ` ${typeof string === "string" ? string.replace(",", "") : string}`,
                        color: ChartColors.pine700,
                        font: {
                            family: "Boston",
                            weight: "700",
                            size: 14,
                        },
                    },
                    grid: {
                        display: false,
                    },
                },
            },
            elements: {
                bar: {
                    borderWidth: 2,
                    borderColor: "transparent",
                    borderRadius: 8,
                },
            },
            plugins: {
                tooltip: {
                    backgroundColor: designTokens.colors.midnight[500],
                    displayColors: false,
                    xAlign: "center",
                    yAlign: "bottom",
                    padding: {
                        x: 12,
                        y: 8,
                    },
                    callbacks: {
                        title: () => "",
                        label: (context) => context.dataset.data[context.dataIndex]?.toString(),
                    },
                },
                legend: {
                    display: false,
                },
            },
        },
    });

export default createBarChart;
